// UI strings around the grammar terms (app/src/grammar/terms: <Term>, <Define>, the term sheet /
// margin card). The terms' own texts are in grammar/terms/*.terms.ts, in both languages.
import { defineArea } from '../area';

export const grammarTermsFi = {
  /** The sheet's title when the term is unknown (a stale link). */
  title: 'Termi',
  unknown: 'Tätä termiä ei löydy.',
  /** Screen readers, on a tappable term: "diftongit, selitys". */
  label: (surface: string) => `${surface}, selitys`,
  /** The term's name in the other language: "Englanniksi: diphthong". */
  otherLang: 'Englanniksi',
  related: 'Katso myös',
  /** The Kielioppi topic where it is explained in full. */
  readMore: 'Kieliopissa',
  /** Above the term's example sentences (Peterson's own, the concept's words marked). */
  examples: 'Esimerkkejä',
};

export const grammarTermsEn: typeof grammarTermsFi = {
  title: 'Term',
  unknown: 'This term was not found.',
  label: (surface) => `${surface}, explanation`,
  otherLang: 'In Finnish',
  related: 'See also',
  readMore: 'In the grammar',
  examples: 'Examples',
};

// Messages.grammarTerms (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('grammarTerms', grammarTermsFi, grammarTermsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof grammarTermsFi> {}
}
